<template>
  <v-form v-model="validForm" ref="contactForm">
    <v-container>

      <v-row class="yellow lighten-5">
        <v-col cols="12" sm="6">
          <NameInput v-model="customer.businessName" :label="$t('Business Name')" />
        </v-col>
        <v-col cols="12" sm="6">
          <NameInput v-model="customer.tin" :label="$t('Business TIN')" />
        </v-col>
      </v-row>

      <v-row class="blue lighten-5">
        <v-col cols="12" sm="6">
          <MsisdnInput v-model="customer.msisdn" />
        </v-col>
        <v-col cols="12" sm="6">
          <EmailInput v-model="customer.email" />
        </v-col>
      </v-row>

      <v-row class="blue lighten-5">
        <v-col cols="12" sm="6">
          <NameInput v-model="customer.firstName" :label="$t('First Name')" />
        </v-col>

        <v-col cols="12" sm="6">
          <NameInput v-model="customer.surname" :label="$t('Surname')" />
        </v-col>
      </v-row>

      <v-row class="red lighten-5">
        <RegionPicker v-model="customer.regions" />
      </v-row>

    </v-container>
  </v-form>
</template>


<script>

  import RegionPicker from '@/components/RegionPicker';
  import MsisdnInput from '@/components/MsisdnInput';
  import EmailInput from '@/components/EmailInput';
  import NameInput from '@/components/NameInput';
  import DateInput from '@/components/DateInput';

  export default {

    components: {
      RegionPicker,
      MsisdnInput,
      EmailInput,
      NameInput,
      DateInput,
    },

    data: () => ({
      customer: {},
      validForm: false,
    }),


    computed: {
      crops() { return this.$store.getters.cropNames; },
    },

  }
</script>


<i18n>
{
  "en": {
    "Business Name": "Business Name",
    "Business TIN": "Business TIN",
    "Primary Crop": "Primary Crop",
    "Secondary Crop": "Secondary Crop",
    "First Name": "Director First Name",
    "Surname": "Director Surname",
    "Notes": "Notes",
    "SaveAndEdit": "Save & Edit",
    "SaveAndAdd": "Save & Add",
    "Clear": "Clear"
  },
  "es": {
    "Business Name": "Business Name",
    "Business TIN": "Business TIN",
    "Primary Crop": "Cultivo Principal",
    "Secondary Crop": "Secondary Crop",
    "First Name": "Primer nombre",
    "Surname": "Apellido",
    "Notes": "Notas",
    "SaveAndEdit": "Salvar o Editar",
    "SaveAndAdd": "Salvar y añadir (Otro Contacto)",
    "Clear": "Reiniciar"
  },
  "sw": {
    "Business Name": "Business Name",
    "Business TIN": "Biashara TIN",
    "Primary Crop": "Mazao ya Msingi",
    "Secondary Crop": "Mazao ya Sekondari",
    "First Name": "Mkurugenzi jina la kwanza",
    "Surname": "Jina la mkurugenzi",
    "Notes": "Noti",
    "SaveAndEdit": "Hifadhi na hariri",
    "SaveAndAdd": "Hifadhi na sajili mwingine",
    "Clear": "Wazi"
  }
}
</i18n>
